let utils = {}
utils.ErrorMessage = []
utils.getTitle = function () {
  return undefined
};
export default utils



// WEBPACK FOOTER //
// ./src/utils/ErrorMessage.js